module.exports = __webpack_public_path__ + "static/img/Box.b45b413e.png";